var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('i18n',{staticClass:"caption",attrs:{"path":"account.settings.deleteAccount.deleteDialog.label","tag":"label","for":"label"}},[_c('strong',[_vm._v(_vm._s(_vm.match))])]),_c('TextField',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }